<template>
  <section class="hero">
    <div class="hero-content">
      <h1>Melinda Hospital</h1>
      <p>
        Kami hadir untuk memberikan layanan medis terbaik bagi Anda dan keluarga,
        dengan fasilitas modern dan tenaga profesional.
      </p>
      <div class="hero-buttons">
        <router-link to="/layanan" class="btn-primary">Lihat Layanan</router-link>
        <router-link to="/contact-us" class="btn-secondary">Hubungi Kami</router-link>
      </div>
    </div>
    <div class="hero-slider" id="hero-slider" @mousedown="startDrag" @mousemove="onDrag" @mouseup="endDrag"
         @mouseleave="endDrag" @touchstart="startDrag" @touchmove="onDrag" @touchend="endDrag">
      <div class="slider-track" :style="trackStyle">
        <img
          v-for="(slide, index) in slides"
          :key="index"
          :src="slide"
          class="slider-image"
          draggable="false"
        />
      </div>
      <div class="dots">
        <span
          v-for="(slide, index) in slides"
          :key="index"
          :class="{ active: currentIndex === index }"
          @click="goTo(index)"
        ></span>
      </div>
    </div>
  </section>
</template>

<script setup>
import { ref, computed, onMounted } from 'vue'

const slides = [
  new URL('@/assets/images/pictures/home-slider/rsiam.webp', import.meta.url).href,
  new URL('@/assets/images/pictures/home-slider/rsm2.webp', import.meta.url).href,
  new URL('@/assets/images/pictures/home-slider/mcvc.webp', import.meta.url).href
]

const currentIndex = ref(0)
const isDragging = ref(false)
const startX = ref(0)
const startY = ref(0)
const currentTranslate = ref(0)
const prevTranslate = ref(0)
const directionLocked = ref(null) // 'horizontal' | 'vertical' | null

function startDrag(e) {
  // console.log('startDrag called')
  const point = e.type.includes('touch') ? e.touches[0] : e
  isDragging.value = true
  startX.value = point.clientX
  startY.value = point.clientY
  prevTranslate.value = -currentIndex.value * 100
  directionLocked.value = null
}

function onDrag(e) {
  if (!isDragging.value) return

  const point = e.type.includes('touch') ? e.touches[0] : e
  const deltaX = point.clientX - startX.value
  const deltaY = point.clientY - startY.value

  // Tentukan arah dominan setelah sedikit gerakan
  if (!directionLocked.value) {
    if (Math.abs(deltaX) > 10) {
      directionLocked.value = 'horizontal'
    } else if (Math.abs(deltaY) > 10) {
      directionLocked.value = 'vertical'
    }
  }

  // Jika vertikal, biarkan scroll halaman
  if (directionLocked.value === 'vertical') {
    isDragging.value = false
    return
  }

  // Jika horizontal, geser slider dan cegah scroll
  if (directionLocked.value === 'horizontal') {
    e.preventDefault()
    currentTranslate.value = prevTranslate.value + (deltaX / window.innerWidth) * 100
  }
}

function endDrag() {
  if (!isDragging.value) return
  isDragging.value = false

  const moved = currentTranslate.value - (-currentIndex.value * 100)

  if (moved < -20 && currentIndex.value < slides.length - 1) {
    currentIndex.value++
  } else if (moved > 20 && currentIndex.value > 0) {
    currentIndex.value--
  }

  currentTranslate.value = -currentIndex.value * 100
}

function goTo(index) {
  currentIndex.value = index
  currentTranslate.value = -index * 100
}

const trackStyle = computed(() => ({
  transform: `translateX(${currentTranslate.value}%)`,
  transition: isDragging.value ? 'none' : 'transform 0.4s ease'
}))
onMounted(() => {
  const el = document.getElementById('hero-slider')
  if (el) {
    el.addEventListener('touchstart', () => {
      console.log('native touchstart received')
    })
    el.addEventListener('mousedown', () => {
      console.log('native mousedown received')
    })
  }
  currentTranslate.value = -currentIndex.value * 100
})
</script>

<style scoped>
.hero {
  display: flex;
  flex-wrap: wrap;
  align-items: start;
  justify-content: space-between;
  padding: 0;
  background-color: var(--navy);
  color: var(--white);
  flex-direction: row;
}

.hero-content {
  flex: 1;
  /* min-width: 300px; */
  /* max-width: 600px; */
  padding: 0 20px 0 10%;
}

.hero-content h1 {
  font-size: 2rem;
  margin-bottom: 20px;
}

.hero-content p {
  font-size: 0.9rem;
  margin-bottom: 30px;
}

.hero-buttons {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
}

.hero-buttons a {
  padding: 12px 24px;
  text-decoration: none;
  border-radius: 100px;
  font-weight: bold;
  text-align: center;
}

.btn-primary {
  background-color: var(--primary);
  color: white;
}

.btn-secondary {
  background-color: var(--cream);
  color: var(--grey);
}

.hero-slider {
  flex: 1;
  max-width: 600px;
  overflow: hidden;
  user-select: none;
  touch-action: pan-y;
  cursor: grab;
  position: relative;
}

.slider-track {
  display: flex;
  transition: transform 0.4s ease;
}

.slider-image {
  width: 100%;
  flex-shrink: 0;
  pointer-events: none;
  transition: opacity 0.3s ease;
}

.dots {
    position: absolute;
    width: 100%;
    bottom: 10px;
    left: 0;
    text-align: center;
    z-index: 1;
    display: flex;
    justify-content: center;
    gap: 8px;
}

.dots span {
  width: 12px;
  height: 12px;
  background-color: #ccc;
  border-radius: 50%;
  display: inline-block;
  cursor: pointer;
  transition: background-color 0.3s;
}

.dots span.active {
  background-color: #00529b;
}

@media (max-width: 1500px){
    .hero-content{
        padding: 0 20px 20px 5%;
    }
}

@media (max-width: 768px) {
  .hero {
    flex-direction: column-reverse;
  }

  .hero-content{
    padding: 0 2.5% 20px 2.5%;
  }

  .hero-content h1 {
    font-size: 1.5rem;
  }

  .hero-slider {
    max-width: 100%;
  }
}
@media (max-width: 600px) {
    .hero-buttons {
        flex-direction: column;
    }

    .hero-buttons a {
        width: 100%;
    }
}
</style>
